"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var typography = _a.typography;
    return ({
        text: {
            wordBreak: 'break-word',
            lineHeight: typography.h2.lineHeight
        }
    });
});
exports.default = useStyles;
